import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  banner: any = {
    pagetitle: "Contact us",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Contact Us",
  }

  constructor() { }

  ngOnInit(): void {
  }

}
